export enum PlanetMediaPlayerImplementation {
    VideoJs = 'videojs',
}
